import { useState } from "react"
import { IContactTeam, ISendMail } from "../models/common/IUserProfile"
import { createFeedback } from "../action/common/commonActionCreator"
import { connect } from "react-redux"
import { getAlertData } from "../helper/sweet-alert"
import { UserRole } from "../constants/RoleEnum"
import { BarLoader } from "react-spinners"
import SweetAlert from "react-bootstrap-sweetalert"
import { baseURL } from "../constants/commonConstants"
import { mailValidation } from "../common-functions/commonFunctions"


const ContactTeamModal = (props: IContactTeam) => {
    const { setShowContactTeam, toMailId, SendFeedback, currentUser } = props
    const [subject, setSubject] = useState<string>("");
    const [content, setContent] = useState<string>("");
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [alertType, setAlertType] = useState<any>("success");
    const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
    const [alertTitle, setAlertTitle] = useState<string>("Default");
    const [isSending, setIsSending] = useState<boolean>(false);

    const onSend = () => {

        let alertData = mailValidation(subject, content, [toMailId])
        if (alertData) {
            setShowAlert(true);
            setAlertType(alertData.type);
            setAlertTitle(alertData.title);
            return
        }

        setIsSending(true);

        const mailData: ISendMail = {
            toEmail: [toMailId],
            subject: subject,
            content: `${content}\<br>\<br>Regards,\<br>${currentUser.displayName}\<br>${currentUser.currentRole && UserRole[currentUser.currentRole]}`,
        };
        SendFeedback(mailData, setAlert);
    }

    const setAlert = (type: string) => {
        let alertData = getAlertData(type);
        if (alertData) {
            setShowAlert(true);
            setAlertType(alertData.type);
            setAlertTitle(alertData.title);
        }
    };

    const onConfirm = () => {
        setShowAlert(false);
        if (subject && content) {
            setShowContactTeam(false)
        }
        setIsSending(false);
    };

    const onCancel = () => {
        setShowContactTeam(false)
    }

    return (
        <>

            <div className="modal-body">
                <h2>Compose</h2>
                <p>Summarize your query briefly and send it to the recipient. You can expect a reply within 24 hours.</p>

                <div className="emailform mt-3">
                    <div className="label-to">
                        <label htmlFor="">From</label>
                        <div className="stude-details">
                            <div className="img">
                                <img src={currentUser?.image ? baseURL + currentUser.image : ""} alt="" />
                            </div>
                            <div className="desc">
                                <h6>{currentUser?.displayName}</h6>
                                <p>{currentUser?.currentDepartment?.name} | <span>{currentUser?.currentCollege?.name}</span></p>
                            </div>
                        </div>
                    </div>
                    <div className="formgroup">
                        <label htmlFor="">To</label>
                        <input type="text" value={toMailId} disabled={toMailId ? false : true} />
                        <BarLoader color="#948256" loading={toMailId ? false : true} width={"100%"} />
                    </div>
                    <div className="formgroup">
                        <label htmlFor="">Subject</label>
                        <input type="text" value={subject} id="subject" onChange={(e) => setSubject(e.target.value)} />
                    </div>
                    <div className="formgroup">
                        <label htmlFor="">Message</label>
                        <textarea name="" value={content} id="message" onChange={(e) => setContent(e.target.value)}></textarea>
                    </div>
                </div>
            </div>
            <div className="modal-footer mb-4">
                <button type="button" className="btn btn-primary" onClick={onSend} disabled={isSending}>Send</button>
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={onCancel}>Cancel</button>
            </div>
            <SweetAlert
                show={showAlert}
                success={false}
                type={alertType}
                title={alertTitle}
                onConfirm={() => onConfirm()}
                showCancel={showAlertCancel}
                onCancel={() => {
                    setShowAlert(false);
                    setShowAlertCancel(false);
                }}
                cancelBtnText={"No"}
                confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
            ></SweetAlert>
        </>
    )
}

const mapDispatchToProps = {
    SendFeedback: (Feedback: ISendMail, callback: Function) =>
        createFeedback(Feedback, callback),
};

function mapStateToProps(state: any) {
    return {
        toMailId: state.common.campusSafetyToMailId,
        currentUser: state.userDetails.userProfileData
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactTeamModal);
